module.exports = __webpack_public_path__ + "static/media/Screenshot_1.f6f98cb1.png";